module.exports = __webpack_public_path__ + "media/src/assets/Images/BancoRepublica-d1aad0bef6ced04274ccd2b073f55eac.svg";